import { render } from "./CreativeModeration.vue?vue&type=template&id=47ad66c2"
import script from "./CreativeModeration.vue?vue&type=script&lang=js"
export * from "./CreativeModeration.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__